import React, { useState } from 'react';
import { Container, Segment, Header, Button, Message, TextArea, Form } from 'semantic-ui-react';

const ConfigPage = ({ config}) => {
    const [editableJson, setEditableJson] = useState(JSON.stringify(config, null, 2));
    const [error, setError] = useState(null);

    // Function to handle JSON validation
    const validateJson = () => {
        try {
            JSON.parse(editableJson);
            setError(null); // Clear any previous errors
            alert("JSON is valid!");
        } catch (e) {
            setError("Invalid JSON: " + e.message);
        }
    };


    return (
        <Container>
            <Segment>
                <Form>
                    <TextArea
                        style={{
                            backgroundColor: "#272822", // Dark background
                            color: "#f8f8f2", // Light text
                            padding: "10px", // Increased padding for better readability
                            borderRadius: "5px",
                            overflowX: "auto",
                            fontFamily: "monospace", // Monospace font for code
                        }}
                        value={editableJson}
                        onChange={(e) => setEditableJson(e.target.value)}
                        rows={25} // Increased number of rows for a larger text block
                        cols={100} // Increased number of columns for a larger text block
                    />
                </Form>
                <Button primary onClick={validateJson} style={{ marginTop: "15px", marginRight: "10px" }}>
                    Validate JSON
                </Button>
                {/*<Button secondary onClick={updateConfig} style={{ marginTop: "15px" }}>
                    Update Config
                </Button>*/}
                {error && (
                    <Message negative style={{ marginTop: "15px" }}>
                        <Message.Header>JSON Validation Error</Message.Header>
                        <p>{error}</p>
                    </Message>
                )}
            </Segment>
        </Container>
    );
};

export default ConfigPage;
